module.exports = __webpack_public_path__ + "static/media/findamachanic_banner.2dd6920b.jpeg";